import angular from 'angular';
import { LoadParams } from '../../shared/models/loadparams.model';
import { IApontamentoImportacao } from './models/apontamentosimportacao.model';

export class ApontamentosImportacaoService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public entity: any;
    public entities: Array<any> = [];
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: LoadParams = new LoadParams();
    public loading_deferred: any = null;
    public filter: any = '';

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService
    ) {}

    reload(toLoad: number = 3): Array<IApontamentoImportacao> {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = toLoad;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search(filter: any = undefined): Array<IApontamentoImportacao>  {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;
             Object.keys(this.filters).forEach((k: any) => { delete this.filters[k]; });
            for (var fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    var filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>) => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('meurh_importacoesapontamentos_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });

        });

    }

    load(): Array<IApontamentoImportacao> {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any) => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                        this.after['created_at'] = this.entities[this.entities.length - 1]['created_at'];
                        this.after['importacaoapontamento'] = this.entities[this.entities.length - 1]['importacaoapontamento'];
                    }
                    if (data.length < 20 || this.loadParams.to_load === 1) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('meurh_importacoesapontamentos_list_finished', this.entities);
                    } else {
                        this.loadParams.finished = false;
                    }
                    this.loaded = true;

                    this.loadParams.to_load--;

                    if (this.loadParams.to_load === 0 || data.length <= 20) {
                        this.$rootScope.$broadcast('meurh_importacoesapontamentos_loaded', this.entities);
                    }
                })
                .catch((error: any) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                    this.load();
                });
        }

        return this.entities;
    }

    loadMore(): void {
        this.loadParams.to_load = 3;
        this.load();
    }

    delete(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<{}>((resolve, reject) => {
            this.$http.delete<{}>(
                this.nsjRouting.generate('meurh_importacoesapontamentos_delete', {
                    'importacaoapontamento': id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_importacoesapontamentos_deleted', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_importacoesapontamentos_delete_error', response);
                reject(response);
            });
        });
    }

    _save(entity: any, autosave: boolean): angular.IHttpPromise<any> {
        var method, url;
        if (entity['importacaoapontamento']) {
            method = 'PUT';
            url = this.nsjRouting.generate('meurh_importacoesapontamentos_put', { 'id': entity['importacaoapontamento'] }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('meurh_importacoesapontamentos_create', angular.extend(this.constructors), true);
        }
        if (!autosave) {
            autosave = false;
        }
        this.loading_deferred = this.$q.defer();
        return this.$http({
            method: method,
            url: url,
            data: entity,
            headers: {'Content-Type': undefined},
            timeout: this.loading_deferred.promise
        })
        .finally(() => {
            if (!autosave) {
                entity['$$__submitting'] = false;
            }
        });
    }

    save(entity: any, autosave: boolean = false): void {
        this._save(entity, autosave)
            .then((response: any) => {
                if (response.data.importacaoapontamento) {
                    entity['importacaoapontamento'] = response.data.importacaoapontamento;
                }
                entity['$$_saved'] = true;
                this.$rootScope.$broadcast('meurh_importacoesapontamentos_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            })
            .catch((response: any) => {
                this.$rootScope.$broadcast('meurh_importacoesapontamentos_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            });
    }

    get(identifier: string): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>) => {
            this.$http
                .get(this.nsjRouting.generate('meurh_importacoesapontamentos_get', { 'id': identifier }, true),
                    { timeout: this.loading_deferred.promise })
                .then((response: any) => {
                    this.$rootScope.$broadcast('meurh_importacoesapontamentos_loaded', response.data);
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });
        });
    }

    download(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<File>((resolve, reject) => {
            this.$http.get<File>(
                this.nsjRouting.generate('meurh_importacoesapontamentos_download', {
                    id
                }, true), {
                    timeout: this.loading_deferred.promise,
                    responseType: 'arraybuffer'
                }
            ).then((response) => {
                this.$rootScope.$broadcast('meurh_importacoesapontamentos_downloaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_importacoesapontamentos_download_error', response);
                reject(response);
            });
        });
    }
}
